import { formatCurrency } from "helpers";
import { InvoiceIncomingItemRow } from "services/api/finance/incoming-invoices/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const INCOMING_INVOICE_ITEMS_COLUMNS = (
  t: (key: string) => string,
  /** Simboli jedinica mjere po id-u — stavke ih nose kao šifru (kom, h, kg...). */
  unitSymbols: Record<string, string> = {}
): Column[] => [
  {
    title: "Šifra",
    field: "",
    type: ColumnTypes.custom,
    render: (row: InvoiceIncomingItemRow) => (
      <div className="text-md min-h-[40px] flex items-center font-light text-slate-500">{row.code}</div>
    ),
  },
  {
    title: "Naziv",
    field: "",
    type: ColumnTypes.custom,
    render: (row: InvoiceIncomingItemRow) => (
      <div className="text-md">{row.name}</div>
    ),
  },
  {
    title: "KPD",
    field: "",
    type: ColumnTypes.custom,
    render: (row: InvoiceIncomingItemRow) => (
      <div className="text-md font-light text-slate-500">{row.kpdCode ?? "-"}</div>
    ),
  },
  {
    title: "PDV %",
    field: "",
    type: ColumnTypes.custom,
    render: (row: InvoiceIncomingItemRow) => (
      <div className="text-md font-light text-slate-500">{row.taxRate} %</div>
    ),
  },
  {
    title: "Količina",
    field: "",
    type: ColumnTypes.custom,
    render: (row: InvoiceIncomingItemRow) => (
      <div className="text-md font-light text-slate-500">
        {row.quantity} {row.unitOfMeasureId ? unitSymbols[row.unitOfMeasureId] ?? row.unitOfMeasureId : ""}
      </div>
    ),
  },
  {
    title: "Cijena bez PDV",
    field: "",
    type: ColumnTypes.custom,
    render: (row: InvoiceIncomingItemRow) => (
      <div className="text-md font-light text-slate-500">
        {formatCurrency.format(row.priceWithoutTax ?? 0)}
      </div>
    ),
  },
  {
    title: "Cijena s PDV",
    field: "",
    type: ColumnTypes.custom,
    render: (row: InvoiceIncomingItemRow) => (
      <div className="text-md">
        {formatCurrency.format(row.priceWithTax ?? 0)}
      </div>
    ),
  },
  {
    title: "Rabat",
    field: "",
    type: ColumnTypes.custom,
    render: (row: InvoiceIncomingItemRow) => (
      <div className="text-md font-light text-slate-500">
        {formatCurrency.format(row.discountAmount ?? 0)}
      </div>
    ),
  },
  {
    title: "Ukupno",
    field: "",
    type: ColumnTypes.custom,
    render: (row: InvoiceIncomingItemRow) => (
      <div className="text-md">
        {formatCurrency.format(row.total ?? 0)}
      </div>
    ),
  },
];

/** Napomena stavke ide u podredak — rijetko je popunjena, a širina tablice je već potrošena. */
export const INCOMING_INVOICE_ITEM_CHILD_COLUMNS = (): Column[] => [
  {
    title: "Napomena",
    field: "note",
    type: ColumnTypes.string,
  },
];
